module.exports = __webpack_public_path__ + "img/worldwide_travel_insurance.c48719ed.jpg";